import { theme } from 'antd';

export const lightTheme = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorPrimary: '#2563EB',
        colorPrimaryHover: '#1D4ED8',
        colorSuccess: '#22C55E',
        colorWarning: '#F59E0B',
        colorError: '#EF4444',
        colorInfo: '#0EA5E9',
        colorBgContainer: '#FFFFFF',
        colorBgElevated: '#FFFFFF',
        colorBgLayout: '#F5F7FB',
        colorBorder: '#E5E7EB',
        colorBorderSecondary: '#E5E7EB',
        colorText: '#111827',
        colorTextSecondary: '#374151',
        colorTextTertiary: '#6B7280',
        colorTextQuaternary: '#9CA3AF',
        borderRadius: 8,
        borderRadiusLG: 12,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        fontSize: 14,
        controlHeight: 36,
        controlHeightLG: 44,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)',
        boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.04)',
    },
    components: {
        Button: {
            primaryShadow: 'none',
            defaultShadow: 'none',
            fontWeight: 500,
        },
        Card: {
            colorBgContainer: '#FFFFFF',
            paddingLG: 24,
        },
        Table: {
            colorBgContainer: '#FFFFFF',
            headerBg: '#F9FAFB',
            headerColor: '#374151',
            rowHoverBg: '#F3F8FF',
            borderColor: '#E5E7EB',
            headerBorderRadius: 8,
        },
        Modal: {
            contentBg: '#FFFFFF',
            headerBg: '#FFFFFF',
        },
        Input: {
            colorBgContainer: '#FFFFFF',
            activeBorderColor: '#2563EB',
            hoverBorderColor: '#93C5FD',
        },
        Select: {
            colorBgContainer: '#FFFFFF',
        },
        Menu: {
            itemBg: 'transparent',
            itemColor: '#374151',
            itemHoverBg: '#F3F8FF',
            itemHoverColor: '#2563EB',
            itemSelectedBg: '#E8F2FF',
            itemSelectedColor: '#2563EB',
            iconSize: 18,
            itemBorderRadius: 8,
            itemMarginInline: 8,
            itemMarginBlock: 2,
            itemHeight: 40,
        },
        Layout: {
            siderBg: '#FFFFFF',
            headerBg: '#FFFFFF',
            bodyBg: '#F5F7FB',
        },
        Tabs: {
            inkBarColor: '#2563EB',
            itemSelectedColor: '#2563EB',
            itemHoverColor: '#2563EB',
        },
        Tag: {
            borderRadiusSM: 6,
        },
        Divider: {
            colorSplit: '#E5E7EB',
        },
    },
};
